import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';

@Component({
  selector: 'app-assurance-prevoyance-obseque',
  standalone: true,
  imports: [CommonModule, PageLayoutComponent],
  templateUrl: './assurance-prevoyance-obseque.component.html',
  styleUrls: ['./assurance-prevoyance-obseque.component.scss']
})
export class AssurancePrevoyanceObsequeComponent {
  title = 'Assurance Prévoyance Obsèques';
  subtitle = '';
  heroImage = 'assets/static_pages_images/obseque.jpg';
  
  breadcrumbs = [
    { label: 'Particuliers', link: undefined },
    { label: 'Assurance Prévoyance Obsèque', link: undefined }
  ];

  prevPage = { title: 'Prévoyance IJH',
    link: '/assurance-prevoyance-ijh'
  };

  nextPage = { title: 'Prévoyance Décès',
    link: '/assurance-prevoyance-deces'
  };

  partners = [
    { name: 'GENERALI', logo: 'assets/images/logos/generali-logo.png' },
    { name: 'APRIL', logo: 'assets/images/logos/april-logo.png' },
    { name: 'SWISSLIFE', logo: 'assets/images/logos/swisslife-logo.png' },
    { name: 'CARDIF', logo: 'assets/images/logos/cardif-logo.png' },
    { name: 'UTWIN', logo: 'assets/images/logos/utwin-logo.png' },
    { name: 'NEOLIANE', logo: 'assets/images/logos/neoliane-logo.png' },
    { name: 'AFIESCA', logo: 'assets/images/logos/afiesca-logo.png' },
    { name: 'APIVIA', logo: 'assets/logos/APIVIA.png' }
  ];

  constructor(private router: Router) {}

  navigateToComparison(): void {
    this.router.navigate(['/cac/comparaison']);
  }
}

